import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import {
  clearInstanceState,
  setSelectedDeerFlowInstances,
} from "../redux/slice";
import { TDeerFlowInstance } from "../redux/types";

export const useDeerFlowInstancesAutocomplete = () => {
  const dispatch = useAppDispatch();

  const handleSelectInstance = (app: TDeerFlowInstance | null) => {
    dispatch(clearInstanceState());
    dispatch(setSelectedDeerFlowInstances(app));
  };

  return {
    handleSelectInstance,
  };
};
